<template>
  <b-card
    :title="
      translations[
        !attributesData.user_account_attribute_definition_id
          ? 'createNewAttribute'
          : 'editAttribute'
      ][lang]
    "
    @cancel="$emit('close')"
    @submit="saveAttribute()"
    :submit-text="translations.save"
    :cancel-text="translations.cancel"
    :loading="loading"
  >
    <v-row no-gutters>
      <v-col cols="12" md="12">
        <b-text-field :label="translations.name[lang]" v-model="attributesData.name"></b-text-field>
      </v-col>
      <v-radio-group
        class="mt-4 mb-4"
        v-model="attributesData.value_type"
        row
        hide-details
        mandatory
        :readonly="attributesData.used"
      >
        <template v-slot:label>
          <div class="pl-3 pr-3 text-body-2 font-weight-medium">{{ translations.type[lang] }}:</div>
        </template>
        <v-radio
          class="mr-10 ml-4"
          color="secondary"
          :label="translations.text[lang]"
          value="text"
        ></v-radio>
        <v-radio :label="translations.number[lang]" color="secondary" value="number"></v-radio>
      </v-radio-group>
      <v-col cols="12">
        <b-select
          :items="attributeOptions"
          :label="translations.input[lang]"
          :readonly="attributesData.used"
          item-text="typeName"
          item-value="attribute_type"
          v-model="attributesData.attribute_type"
        ></b-select>
      </v-col>
      <v-col v-if="selectedAttributeOption.value && selectedAttributeOption.value.length" cols="12">
        <v-simple-table class="mt-4 pr-2 pl-2" style="border: 1px solid rgb(158, 158, 158)">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-center">
                  <div>
                    <span class="font-weight-bold">{{ translations.options[lang] }}</span>
                    <span class="font-weight-medium ml-1"
                      >{{ translations.for[lang] }} {{ selectedAttributeOption.typeName }}</span
                    >
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, i) in selectedAttributeOption.value" :key="i">
                <td>
                  <div class="d-flex justify-center align-center mt-2 mb-2">
                    <v-text-field
                      autofocus
                      class="no-border-field input-text-center"
                      :label="`${translations.option[lang]} ${i + 1}`"
                      outlined
                      dense
                      color="secondary"
                      hide-details
                      :readonly="
                        attributesData.used && !!item.user_account_attribute_definition_value_id
                      "
                      v-model="selectedAttributeOption.value[i].value"
                      :append-icon="
                        (!(
                          attributesData.used && item.user_account_attribute_definition_value_id
                        ) &&
                          selectedAttributeOption.value.length > 1 &&
                          icons.mdiCloseCircle) ||
                        ''
                      "
                      @click:append="removeAttributeOption(i)"
                      @change="updateAttributesDataOptions(i)"
                    ></v-text-field>
                  </div>
                  <div
                    v-if="
                      attributesData &&
                      attributesData.value_type == 'number' &&
                      isNaN(selectedAttributeOption.value[i]?.value)
                    "
                    class="d-flex justify-center mb-2 mt-n2"
                  >
                    <span class="error--text">{{ translations.invalidValue[lang] }}</span>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div
                    v-if="selectedAttributeOption.value[selectedAttributeOption.value.length - 1]"
                    class="d-flex justify-center align-center mt-2 mb-2"
                  >
                    <v-tooltip color="secondary" top>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          class="text-capitalize"
                          depressed
                          fab
                          v-on="on"
                          @click="addNewOption()"
                        >
                          <v-icon size="30" v-text="icons.mdiPlus"></v-icon>
                        </v-btn>
                      </template>
                      <span
                        class="font-weight-bold"
                        v-text="translations.addNewOption[lang]"
                      ></span>
                    </v-tooltip>
                  </div>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
  </b-card>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import { cloneDeep } from 'lodash';
import translations from '@/utils/translations/loyaltyPanel/customers';
import { mdiPlus, mdiCloseCircle } from '@mdi/js';

export default {
  name: 'AttributesTab',
  mixins: [translations],
  data() {
    return {
      icons: {
        mdiPlus,
        mdiCloseCircle,
      },
      attributesDialog: false,
      attributeOptions: [
        {
          typeName: 'Text',
          attribute_type: 'text',
          value: [],
        },
        {
          typeName: 'Select One',
          attribute_type: 'select',
          value: [
            {
              user_account_attribute_definition_value_id: null,
              value: null,
            },
          ],
        },
        {
          typeName: 'Select Multiple',
          attribute_type: 'multi_select',
          value: [
            {
              user_account_attribute_definition_value_id: null,
              value: null,
            },
          ],
        },
        {
          typeName: 'Radio Buttons',
          attribute_type: 'radio',
          value: [
            {
              user_account_attribute_definition_value_id: null,
              value: null,
            },
          ],
        },
      ],
      attributesData: { options: [] },
    };
  },
  computed: {
    ...mapState(['loading', 'superUser', 'permissions']),
    ...mapState('loyaltyPanel/customers', ['attributes', 'attribute']),

    lang() {
      return this.$route.params.lang;
    },

    attributeId() {
      return this.attribute?.user_account_attribute_definition_id;
    },

    selectedAttributeOption() {
      return (
        this.attributeOptions.find((x) => x.attribute_type == this.attributesData.attribute_type) ||
        {}
      );
    },
  },
  methods: {
    ...mapActions('loyaltyPanel/customers', [
      'getAttributes',
      'createAttribute',
      'updateAttribute',
    ]),
    getPermission(path) {
      return this.superUser || eval('this.permissions.' + path);
    },
    async saveAttribute() {
      this.attributesData.options = this.attributesData.user_account_attribute_definition_values
        ? [...this.attributesData.user_account_attribute_definition_values]
        : [];

      let id = this.attributesData.user_account_attribute_definition_id;
      let res;
      if (id) {
        res = await this.updateAttribute({ ...this.attributesData });
      } else {
        res = await this.createAttribute({ ...this.attributesData });
      }
      if (res && !res.error) {
        await this.getAttributes();
        this.attributesData = { options: [] };
        this.$emit('close');
      }
    },
    removeAttributeOption(i) {
      this.selectedAttributeOption.value.splice(i, 1);
      this.attributesData.user_account_attribute_definition_values.splice(i, 1);
    },
    addNewOption() {
      this.selectedAttributeOption.value.push({
        user_account_attribute_definition_value_id: null,
        value: null,
      });
    },
    updateSelectedAttributeOptionValues(values) {
      const idx = this.attributeOptions.findIndex(
        (x) => x.attribute_type === this.attributesData.attribute_type
      );
      if (idx !== -1) {
        this.$set(this.attributeOptions[idx], 'value', [...values]);
      }
    },
    updateAttributesDataOptions(i) {
      if (!this.attributesData.user_account_attribute_definition_values) {
        this.attributesData.user_account_attribute_definition_values = [];
      }
      if (!this.attributesData.user_account_attribute_definition_values[i]) {
        this.attributesData.user_account_attribute_definition_values[i] = {};
      }
      this.attributesData.user_account_attribute_definition_values[
        i
      ].user_account_attribute_definition_value_id =
        this.selectedAttributeOption.value[i].user_account_attribute_definition_value_id;
      this.attributesData.user_account_attribute_definition_values[i].value =
        this.selectedAttributeOption.value[i].value;
    },
  },
  mounted() {
    // this.getAttributes();
  },
  watch: {
    attributeId: {
      handler(val) {
        this.attributeOptions.forEach((e) => {
          if (e?.value?.length) {
            this.$set(e, 'value', [
              {
                user_account_attribute_definition_value_id: null,
                value: null,
              },
            ]);
          }
        });
        this.attributesData.options = this.attributesData.options || [];
        if (this.attributesData.options?.[0]) {
          this.updateSelectedAttributeOptionValues(
            this.attributesData.user_account_attribute_definition_values
          );
        }
      },
      immediate: true,
    },

    attributesData: {
      handler(val) {
        if (val?.user_account_attribute_definition_values?.[0]) {
          this.selectedAttributeOption.value = [...val.user_account_attribute_definition_values];
        }
      },
      deep: true,
    },

    attribute: {
      handler(val) {
        this.attributesData = val.user_account_attribute_definition_id
          ? cloneDeep(val)
          : { options: [] };
      },
      immediate: true,
    },
  },
};
</script>
